<template lang="pug">
    table(class="w-full")
        tbody
            tr(v-if="data.promo")
                td(class="relative pb-3 w-full" colspan="2")
                    strong(v-if="data.promo.title" class="uppercase block text-danger") {{ data.promo.title }} #[span(v-if="data.promo.title && data.promo.content")]
                    |
                    | {{ data.promo.content }}
                    |
                    span(v-if="data.promo && data.promo.file" class="block") #[a( :href="getFileUrl(data.promo.file.folder, data.promo.file.filename)" target="_blank") See More].

            tr(v-if="data.discount")
                td(class="relative font-bold uppercase pb-3 w-full text-danger" colspan="2")
                    strong Now {{ data.discount.amountFormatted}} off
                    |  - hurry,
                    span(v-if="data.discount.expiresFormatted")
                        |  offer ends {{ data.discount.expiresFormatted }}!
                    span(v-else)
                        |  limited time offer!

            tr(v-if="data.isMadeInAmerica")
                td(class="text-left pb-3")
                    img(
                        src="@/assets/us-flag.svg"
                        alt="Made in the USA"
                        loading="lazy"
                        class="max-w-none"
                        width="40"
                        height="37"
                    )
                td(class="relative pb-3 pl-5 w-full")
                    | Made in the USA

            //- VehicleSelection breaks group product drill down updates, do not render if group product
            tr(v-if="!isGroupProduct")
                td(colspan="2" class="pb-4 md:pb-0")
                    VehicleSelection

            //- This shipping related info should only show when the item is inStock
            //- and when we have a single sku
            template(v-if="!data.isOutOfStock && (data.mpn || data.sku)")
                template(v-if="shippingText")
                    tr(class="pb-4 md:pb-0")
                        td(class="text-left pb-3")
                            SameDayShippingLogo(
                                v-if="$sitewideData.config.sameDayShippingEnabled && data.shipping.sameDay"
                                class="inline-block h-auto"
                                style="width: 40px;max-height: 37px;"
                                isIcon
                            )
                            FreightBox(
                                v-else-if="data.shipping.isFreight"
                                class="inline-block align-middle w-10 h-auto text-action-dark stroke-current fill-current"
                                style="max-height: 37px;"
                            )
                            div(
                                v-else
                                class="relative rounded-full bg-success p-5 w-[35px] h-[35px] md:p-3"
                            )
                                img(
                                    src="@/assets/common/checkmarkThick.svg"
                                    alt="checkmark"
                                    class="w-[20px] icon absolute m-auto inset-0 fill-current text-white"
                                    loading="lazy"
                                )

                        td(class="relative pb-3 pl-6 w-full md:pb-4")
                            p(class="font-bold uppercase text-black") {{ shippingText }}
                            //- The other stuff that this can show doesn't matter here so
                            //- we only show the shipping comp if we are sameDay
                            Shipping(
                                v-if="$sitewideData.config.sameDayShippingEnabled && data.shipping.sameDay"
                                :data="data"
                            )

                tr(v-if="data.shipping.estimatedDeliveryDate")
                    td(class="text-left pb-3")
                        div(class="relative rounded-full bg-success p-5 w-[35px] h-[35px] md:p-3")
                            img(src="@/assets/common/checkmarkThick.svg" alt="checkmark" class="w-[20px] icon absolute m-auto inset-0 fill-current text-white" loading="lazy")
                    td(class="relative pb-3 pl-6 w-full")
                        Shipping(:data="data")

            tr(v-if="data.mpn || data.sku")
                td(class="font-normal text-left uppercase text-sm pb-3")
                    span(class="inline-block whitespace-nowrap max-w-[30px]") Part #:
                td(class="pb-3 pl-6 w-full") {{ ($sitewideData.config.showMpn && data.mpn) || data.sku }}

            tr(v-if="data.upc")
                td(class="font-normal text-left uppercase text-sm  pb-3")
                    span(class="inline-block whitespace-nowrap max-w-[30px]") UPC:
                td(class="pb-3 pl-6 w-full") {{ data.upc }}

            tr(
                v-if="isProductPage"
                v-for="attr in data.attributes"
            )
                td(class="font-normal text-left uppercase text-sm  pb-3") {{ attr.key }}:
                td(class="pb-3 pl-6 w-full") {{ attr.value}}

            installernetWrapper(
                v-if="data.skuSlug && $geolocation.enabled && $installernet.enabled && data.shipping && data.shipping.sameDay"
                mode="ADD_TO_CART"
                :item="data"
            )

</template>

<script>
import SameDayShippingLogo from '@/components/shipping/sameDayLogo'
import { sameDayShippingDisplayMixin, getFreeShippingText } from '@/helpers/shipping'
import { getFileUrl } from '../_helpers/getFileUrl'
import VehicleSelection from './vehicleSelection/'

const FreightBox = () =>
    import(/* webpackChunkName: "asset-freight-box" */ '@/assets/shipping/freightBox?inline')
const Shipping = () => import(/* webpackChunkName: "shipping" */ '@/components/shipping')

const installernetWrapper = () =>
    import(/* webpackChunkName: "integrations-installernet" */ '@/integrations/installernet')

export default {
    components: {
        FreightBox,
        Shipping,
        SameDayShippingLogo,
        installernetWrapper,
        VehicleSelection,
    },
    mixins: [sameDayShippingDisplayMixin],
    props: {
        data: {
            type: Object,
            required: true,
        },
        isGroupProduct: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        shippingText() {
            if (this.$sitewideData.config.sameDayShippingEnabled && this.data.shipping.sameDay)
                // this value comes from the sameDayShippingDisplayMixin
                return `${this.sameDayShippingText} Ready`

            return getFreeShippingText(this.data.shipping)
        },
    },
    watch: {
        'data.shipping'(newVal) {
            this.checkExpressShipping(newVal)
        },
    },
    mounted() {
        this.checkExpressShipping(this.data.shipping)
    },
    methods: {
        getFileUrl,
        checkExpressShipping(shipping) {
            if (shipping.sameDay)
                this.$uiEvents.$emit('expressShippingViewed', this.$route.fullPath)
        },
    },
}
</script>
